module.exports = __webpack_public_path__ + "img/charging-infrastructure-terms.3af0981e.jpg";